<template>
    <div>
        <v-row class="d-flex text-center pb-4 cardText">
            {{ $t('texts.emailVerfificationSuccessMessage') }}
        </v-row>
        <v-row class="d-flex justify-center">
            <v-btn class="white--text ma-2" color="#0da6b1" variant="text" @click="okClick">
                {{ $t('buttons.ok') }}
            </v-btn>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'SuccessMessage',
    emits: ['close'],
    methods: {
        okClick() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.cardText {
    font-size: 16px;
    font-weight: 500;
    color: rgba(5, 75, 97, 255);
}
</style>
